<template>
 
 <svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 229.56 220.83">
  <path class="cls-2" d="M211.94,153.74h-6.98l-6.59-83.15c-2.19-24.95-22.76-43.33-47.69-43.33h-1.19c-2.09-14.96-14.73-26.27-30.32-26.27h-8.77c-15.58,0-28.23,11.32-30.32,26.27-24.26.29-44.54,18.57-47.14,42.89,0,.27,0,.5.02.71-.02.06-.02.11-.02.17l-8.12,83.15h-7.21c-9.19,0-16.62,7.44-16.62,16.62v14.89c0,16.62,13.12,29.76,29.76,29.76h15.05c5.68,2.87,12.03,4.38,18.65,4.38h102.84c6.45,0,12.74-1.53,18.35-4.38h13.16c16.64,0,29.76-13.13,29.76-30.19v-14.89c0-9.19-7.44-16.62-16.62-16.62ZM110.4,9.75h8.77c10.5,0,19.25,7.45,21.44,17.52h-51.65c2.19-10.06,10.94-17.52,21.44-17.52ZM78.8,36.06c.6-.03,1.22-.05,1.84-.05h69.59c.6,0,1.21.02,1.81.05.35.02.68.05,1.03.06.24.02.48.03.73.05.5.05,1,.11,1.48.17.06.02.12.02.18.03,16.46,2.18,29.71,14.48,33.28,30.72-6.51,17.79-18.92,32.28-34.58,41.42v-41.86h4.38c2.63,0,4.38-1.75,4.38-4.38s-1.75-4.37-4.38-4.37h-17.5c-2.63,0-4.38,1.75-4.38,4.37s1.75,4.38,4.38,4.38h4.37v46.26c-9.48,4.05-19.84,6.26-30.63,6.26s-21.16-2.15-30.63-6.11v-46.41h4.37c2.63,0,4.38-1.75,4.38-4.38s-1.75-4.37-4.38-4.37h-17.5c-2.63,0-4.38,1.75-4.38,4.37s1.75,4.38,4.38,4.38h4.38v42.09c-14.89-8.54-26.84-21.91-33.7-38.58,2.54-19.07,18.23-33.23,37.1-34.09ZM154.16,145.43v8.75h-8.75v-8.75h8.75ZM84.15,145.43v8.75h-8.75v-8.75h8.75ZM30.76,206.69c-11.82,0-21.01-9.19-21.01-21.01v-14.89c0-4.37,3.49-7.87,7.87-7.87h6.36l-1.1,11.38c-.09,1.1-.14,2.21-.12,3.31-.02,10.29,3.46,19.84,10.11,27.55.32.36.62.73.94,1.09.14.15.27.29.41.44h-3.46ZM189.62,201.87c-1.93,1.95-4.14,3.63-6.53,5-.17.09-.32.18-.47.26-.14.06-.26.14-.38.21-4.44,2.39-9.52,3.73-14.95,3.73h-102.4c-9.19,0-18.39-3.94-24.51-10.94-6.56-6.57-9.63-15.76-8.75-24.95l1.75-16.2c0-.41-.06-.82-.14-1.21l6.68-72.06c8.57,14.3,20.9,25.63,35.47,32.94v18.01h-4.38l-4.37,4.37v17.52l4.37,4.37h17.5l4.38-4.37v-17.52l-4.38-4.37h-4.37v-14.22c9.58,3.55,19.92,5.46,30.63,5.46s21.02-1.95,30.63-5.55v14.31h-4.37l-4.38,4.37v17.52l4.38,4.37h17.5l4.38-4.37v-17.52l-4.38-4.37h-4.38v-18.16c15.08-7.62,27.84-19.56,36.45-34.55l7.31,92.53c.15,1.68.18,3.31.11,4.91-.32,5.08-1.57,9.76-3.66,13.81-1.28,2.4-2.87,4.64-4.76,6.65ZM219.81,185.69c0,11.82-9.63,21.01-21.01,21.01h-1.75c2.93-3.48,5.24-7.48,6.88-11.89,1.84-4.82,2.84-10.05,2.87-15.52.05-1.63,0-3.29-.12-4.97l-.86-11.38h6.12c4.38,0,7.87,3.51,7.87,7.87v14.89Z"/>
  <rect class="cls-1" x="145.41" y="145.43" width="8.75" height="8.75"/>
  <rect class="cls-1" x="75.4" y="145.43" width="8.75" height="8.75"/>
</svg>
</template>
<style>
.cls-1 {
  fill: none;
  stroke: var(--ion-color-secondary);
  stroke-linecap: round;
  stroke-miterlimit: 10;
  stroke-width: 5px;
}
svg{
  fill: var(--ion-color-secondary);
}
.cls-1 {
  fill: none;
  stroke-width: 6px;
}

.cls-1 {
        stroke-width: 3px;
}

.cls-1, .cls-2 {
  fill: var(--ion-color-secondary);
  stroke:var(--ion-color-secondary);
  stroke-miterlimit: 10;
}

.cls-2 {
  stroke-width: 2px;
}
</style>